<template>
    <div class="NewsDetail">
        <section-header
        heading="2"
        :ja="title"
        />
        <div class="text-area" v-html="content">
        </div>
        <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
        <sub-btn @click="onHome()">ホームに戻る</sub-btn>
    </div>
</template>

<script>
import Protobuf from "../mixins/protobuf";
import SectionHeader from "../components/SectionHeader";
import SubBtn from "../components/SubBtn.vue";

export default {
name: "NewsDetail",
components: { SectionHeader, SubBtn },
mixins: [Protobuf],
data() {
    return {
    title: "",   // ページタイトル
    content: "", // 本文
    };
},
methods: {
    onNewsList() {
        this.$router.push("/newsList");
    },
    onHome() {
        this.$router.push("/");
    },
    /**
     * 負荷対策ページ用jsonを取得する
     */
    async getPageInfo(){
        try {
            const jsonUrl = 'https://dev-cdn.puri.jp/load_reduction/pages/' + this.$route.params.name + '.json'
            const response = await fetch(jsonUrl)
            const responseJson = await response.json()
            this.title = responseJson.title
            this.content = responseJson.content
        } catch(e) {
            // 該当の負荷対策ページがなければホームへ
            this.$router.push('/')
        }
    }
},
mounted(){
    this.getPageInfo()
}
};
</script>

<style lang="scss" scoped>
.NewsDetail {
.text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
        max-width: 100%;
    }

    p {
        margin-top: 1em;
    }

    .linkArea {
        .twitter {
            margin: 0 5px;
        }
    }

    .centerBlock {
        display: flex;
        justify-content: center;

        & > a:not(:last-of-type) {
            margin-right: 30px;
        }

        & > a:last-of-type {
            margin-left: 18px;
        }
    }
}
}
</style>